import React from 'react';
import { Button } from 'rsuite';
import { ModalsService } from '../../../services/modals.service';
import { RetailDeliveryDescriptionModal } from './retail-delivery-description-modal';

type Props = {
  id: string;
};
export const RetailDeliveryDescriptionButton: React.FC<Props> = (props) => {
  return (
    <Button
      className={
        'btn btn-outline-success align-items-center d-flex text-success'
      }
      onClick={async () => {
        await ModalsService.createModal(RetailDeliveryDescriptionModal, {
          orderId: props.id,
        });
      }}
    >
      Добавить описание
    </Button>
  );
};
